package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.Sex
import com.neurobs.js.dom.ElementFactory.{makeForm, makeSelectBox, makeTextInput}
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.{ForceSelectBox, InputCheckBox, InputTextBox}
import com.neurobs.js.view.{Container, Form, TextBox}
import org.scalajs.dom.html

class CreateSubjectPanel {
	import SubjectListView._

	val anonymous = InputCheckBox(makeCheckbox())
	val firstName = InputTextBox(makeTextI)
	val lastName = InputTextBox(makeTextI)
	val birthdate = InputTextBox(makeTextI)
	val sex =  ForceSelectBox(makeSelectBox(boxWidth))
	val localId = inputTextBox(makeTextI)
	var anonymousChangeHandler: () => Unit = () => Unit

	val panel: Container = {
		val birthDateLabel = makeText(text = "Birthdate (YYYY-MM-DD):")
		val orgIdLabel = makeText(text = "Organization ID (optional):")

		val table = new HideableRowFormTable
		table.addRow(left = "Anonymous:", anonymous.input)
		val firstRow = table.addRow(left = "First name:", firstName.text)
		val lastRow = table.addRow(left = "Last name:", lastName.text)
		table.addRow(birthDateLabel, birthdate.text)
		table.addRow(left = "Sex:", sex.select)
		table.addRow(orgIdLabel, localId.text)

		anonymousChangeHandler = () => {
			val c = anonymous.checked
			table.setRowVisible(firstRow, !c)
			table.setRowVisible(lastRow, !c)
			birthDateLabel.setValue(if (c) "Birth Year:" else "Birthdate (YYYY-MM-DD):")
			orgIdLabel.setValue(if (c) "Organization ID:" else "Organization ID (optional):")
		}
		anonymous.setChangeHandler(anonymousChangeHandler)
		sex.setOptions(Sex.values.toArray.map(_.toString))

		table.container
	}
}

case class CreateSubjectForm
(
	form: Form,
	panel: CreateSubjectPanel
)

object SubjectListView {

	val boxWidth = 20
	val formWidth = 40

	def makeTextI: html.Input = makeTextInput(boxWidth)

	def createSubjectForm(title: String, submitCaption: String): CreateSubjectForm = {
		val panel = new CreateSubjectPanel

		val form = makeForm(
			width = formWidth,
			title = title,
			description = "",
			elements = Array(),
			extraContent = Some(toElement(panel.panel)),
			useCancel = true,
			submitCaption = submitCaption
		)
		CreateSubjectForm(form = form, panel = panel)
	}
}